import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles.less';

export const MaskedImage = ( props ) => {
    const classes = classnames( [
        'masked-image',
        { [ props.className ]: Boolean( props.className ) },
    ] );

    const maskId = useMemo( () => {
        return 'masked-image';
    }, [] );

    return (
        <svg width={ props.width } height={ props.height } version="1.2" className={ classes } style={ props.style }>
            <defs>
                <mask id='masked-image'>
                    <image width="100%" height="100%" href={ props.maskSrc } />
                </mask>
            </defs>
            <image mask={ `url(#${ maskId })` } width="100%" height="100%" href={ props.src } />
            { Boolean( props.overlayColor ) &&
                <rect className="overlay-color" mask={ `url(#${ maskId })` } x="0" y="0" width="100%" height="100%" fill={ props.overlayColor } fillOpacity={ props.overlayOpacity } />
            }
        </svg>
    );
};

MaskedImage.defaultProps = {
    loading: false,
    missing: false,
    overlayColor: undefined,
    overlayOpacity: 0.1,
};

MaskedImage.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    src: PropTypes.string,
    maskSrc: PropTypes.string,
    width: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
    height: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
    overlayColor: PropTypes.string,
    overlayOpacity: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ),
};
